import React from 'react';

const labels = {
  title: 'Descripción', date: 'Fecha', product: 'Producto', archive: 'Archivo',
  area_ha: 'Superficie (ha)', resolution_x: 'Resolución X', resolution_y: 'Resolución Y',
  rows: 'Filas', columns: 'Columnas', value_min: 'Valor mínimo', value_max: 'Valor máximo',
  bands_count: 'Cantidad de bandas', projection: 'Proyección', driver: 'Formato',
  workspace: 'Espacio de trabajo', sensor: 'Sensor', site: 'Sitio', nodata: 'Valor sin datos',
};

export default function LayerInfoContent({ description, local }) {
  if (!description) return <p className="layer-info-empty">No hay metadatos disponibles para esta capa.</p>;
  if (!local || typeof description !== 'string') {
    return <p className="layer-info-description">{String(description)}</p>;
  }
  const lines = description.split('\n').filter(line => line.trim());
  return (
    <dl className="layer-info-fields">
      {lines.map((line, index) => {
        const separator = line.indexOf(':');
        const key = separator < 0 ? 'title' : line.slice(0, separator).trim();
        const value = separator < 0 ? line : line.slice(separator + 1).trim();
        return (
          <div className="layer-info-field" key={index}>
            <dt>{labels[key] || key.replace(/_/g, ' ')}</dt>
            <dd>{value || 'No informado'}</dd>
          </div>
        );
      })}
    </dl>
  );
}
